import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';

import FormControl from '@material-ui/core/FormControl';
import TextField from "@material-ui/core/TextField";
import { Popup } from "@progress/kendo-react-popup";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import InputLabel from '@material-ui/core/InputLabel';
import moment from "moment";
import "moment/locale/fr";
import { loadLocalization } from '../../../utils/kendoLocalization';
import { GetLanguage } from '../../../utils/language';
import AlertAlgo from '../../controls/AlertSnack'
import { savePeriod } from '../../../actions/availability';
import * as StatusCode from '../../../scripts/StatusCode';

import { isEmpty, convertToDate } from '../../../utils';
import styles from '../../../styles/scheduleAvailability.module.css';

import { withNamespaces } from 'react-i18next';

loadLocalization();
moment.locale("fr");

const useStyles = makeStyles((theme) => ({
    rootProfile: {
        overflow: 'auto'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divForm: {
        padding: '10px'
    },
    date: {
        marginBottom: '15px'
    },
    divButtons: {
        textAlign: 'center',
        marginTop: '10px'
    }
}));

function PeriodForm(props) {
    const classes = useStyles();

    const [scheduleAvailabilityId, setScheduleAvailabilityId] = useState(props.scheduleAvailabilityId);
    const [data, setData] = useState(props.data);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [comment, setComment] = useState(null);
    const [locale, setLocale] = useState(GetLanguage());

    const alertRef = useRef(null);

    useEffect(() => {

    }, []);

    useEffect(() => {
        if (scheduleAvailabilityId > 0) {
            const dataFiltered = data.filter(x => x.id == scheduleAvailabilityId);
            setData(dataFiltered);
        }
    }, [scheduleAvailabilityId]);

    useEffect(() => {
        if (scheduleAvailabilityId > 0 && data.length == 1) {
            setStartDate(convertToDate(new Date(data[0].startDate.replace('-', '/'))));
            setEndDate(data[0].endDate != null ? convertToDate(new Date(data[0].endDate.replace('-', '/'))) : null);
            setComment(data[0].comment);
        }
    }, [data]);

    const handleReloadPeriod = () => {
        props.handleReloadPeriod();
    }

    const isValidData = () => {
        let message = '';

        if (isEmpty(startDate)) {
            message = i18next.t('scheduleAvailability:period.message.startDate-form');
        } else if (!isEmpty(endDate) && new Date(startDate) >= new Date(endDate)) {
            message = i18next.t('scheduleAvailability:period.message.endDateGreaterThanStartDate');
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const handleSave = async () => {
        if (isValidData()) {
            const response = await savePeriod(scheduleAvailabilityId, startDate, endDate, comment);

            if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
                // Error
                showMessageError(i18next.t('error:generic-error'));
                return;
            } else if (response.result.codeReturn == -1) {
                // Conflict date
                showMessageError(i18next.t('scheduleAvailability:period.message.conflict-date-error'));
                return;
            }

            handleReloadPeriod();
        }
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const onStartDateChange = (event) => {
        setStartDate(event.target.value);
    }

    const onEndDateChange = (event) => {
        setEndDate(event.target.value);
    }

    const onChangeComment = (event) => {
        setComment(event.target.value);
    }

    let _el;

    return (
        <div id={"divPeriodForm"} className={styles.rootSchedulePopBody} style={{ top: '80px' }}>
            <LocalizationProvider language={locale}>
                <IntlProvider locale={locale}>
                    <div className={classes.date} ref={el => (_el = el)}>
                        <InputLabel className={"labelDatePicker required"} htmlFor="startDate">{i18next.t('scheduleAvailability:period.form.startDate')}</InputLabel>
                        <DatePicker
                            className={styles.inputDate}
                            name="startDate"
                            value={startDate}
                            onChange={onStartDateChange}
                            format="yyyy-MM-dd"
                            popup={props => <Popup {...props} appendTo={_el} />} />
                    </div>

                    <div className={classes.date} ref={el => (_el = el)}>
                        <InputLabel className={"labelDatePicker"} htmlFor="endDate">{i18next.t('scheduleAvailability:period.form.endDate')}</InputLabel>
                        <DatePicker
                            className={styles.inputDate}
                            name="endDate"
                            value={endDate}
                            onChange={onEndDateChange}
                            format="yyyy-MM-dd"
                            popup={props => <Popup {...props} appendTo={_el} />} />
                    </div>

                    <FormControl fullWidth>
                        <TextField
                            id="comment"
                            label={i18next.t('scheduleAvailability:period.form.comment')}
                            value={comment || ''}
                            multiline
                            minRows={4}
                            onChange={onChangeComment}
                        />
                    </FormControl>
                    <div className="divButtons">
                        <Button onClick={handleSave} variant="success" className="saveButton">
                            {i18next.t('buttons:save')}
                        </Button>
                    </div>
                    <AlertAlgo ref={alertRef} />
                </IntlProvider>
            </LocalizationProvider>
        </div>
    );
}

export default withNamespaces(['buttons', 'scheduleAvailability', 'error'], { wait: true })(PeriodForm);